import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuelidate from 'vuelidate'
import { VPopover } from 'v-tooltip'
import Clipboard from 'v-clipboard'
import numeral from 'numeral'
import Moment from 'moment'
import { extendMoment } from 'moment-range'
import { getEnvVar } from '@/assets/js/helpers'

// Components
import icon from './components/Icon'
import Dropdown from './components/Dropdown'

const moment = extendMoment(Moment)
require('moment/src/locale/ru')

Vue.component('icon', icon)
Vue.component('Dropdown', Dropdown)
Vue.component('v-popover', VPopover)
Vue.component('Icon', () => import('@rr-component-library/icon/src/main'))

Vue.use(Clipboard)

// numeral.js settings
numeral.register('locale', 'ru', {
  delimiters: {
    thousands: ' ',
    decimal: ','
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't'
  },
  ordinal: function () {
    return ''
  },
  currency: {
    symbol: '₽'
  }
})
numeral.locale('ru')

// moment.js settings
moment.locale('ru')

Vue.config.productionTip = false
Vue.use(Vuelidate)

Vue.prototype.$numeral = numeral
Vue.prototype.$moment = moment

Vue.directive('open-modal', function (el, binding) {
  el.addEventListener('click', function (e) {
    e.preventDefault()
    const modal = Main.$modals[binding.value.name]
    if (modal) {
      modal.open()
    }
  })
})

Vue.directive('click-outside', {
  bind (el, binding) {
    const { bubble } = binding.modifiers
    const handler = (e) => {
      if (bubble || (!el.contains(e.target) && el !== e.target)) {
        binding.value(e)
      }
    }
    el.__vueClickOutside__ = handler
    document.addEventListener('click', handler)
  }
})

const tenantData = require(`@/assets/${process.env.VUE_APP_TENANT}.json`)

Vue.prototype.$getTenantImg = (name) => {
  if (!name || !tenantData) {
    return null
  }
  const path = tenantData.img ? tenantData.img[name] : null
  if (!path) {
    return null
  }
  if (path.indexOf(tenantData.img.PATH || 'tenants/') !== 0) {
    return path
  }
  return require(`@/assets/img/${path}`)
}

Vue.prototype.$getTenantIdClub = () => {
  return tenantData ? tenantData.idClub : null
}

Vue.prototype.$getTenantIsMemberLinks = () => {
  if (!tenantData) {
    return true
  } else {
    return tenantData.isMemberLinks
  }
}

Vue.prototype.$getEnvVar = getEnvVar

const Main = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
